namespace GeniuzPOS.Administration {
    export interface RolePermissionListResponse extends Serenity.ListResponse<string> {
    }
}
